export function Brand({ size = 'md', light = false }) {
  return <div className={`brand brand-${size} ${light ? 'light' : ''}`} data-testid="brand">
    <img src="/logo-mark.png" alt="PatronSoft" className="brand-logo" />
    <span className="brand-name">Patron<span>Soft</span></span>
  </div>;
}
